<template>
  <Teleport to="#app">
    <div
      ref="MainContent"
      class="fixed top-0 z-40 w-full h-full p-5 left-full sm:p-10"
    >
      <div
        data-dialog-box
        class="relative z-10 flex flex-col h-full overflow-y-auto bg-white rounded-2xl"
      >
        <!-- header -->
        <div class="w-full p-5 border-b border-zinc-300">
          <div class="flex items-center justify-between w-full mb-2">
            <p class="text-xl font-light">
              {{
                active_category_id == "all"
                  ? "全部車款"
                  : category_data.find(
                      (item) => item.MenuID == active_category_id
                    ).Title
              }}
            </p>
            <button @click="dialog = false"><i class="icon-close"></i></button>
          </div>
          <p class="text-sm work_sans text-zinc-400">
            {{ category_product_data.length }} 項商品
          </p>
        </div>
        <!-- header -->
        <div class="flex-1 w-full p-5">
          <div class="mb-5">
            <p class="mb-3 font-medium">搜尋關鍵字</p>

            <TextField
              name="key_word"
              type="text"
              placeholder="關鍵字"
              :value="edit_key_word"
              :show_error="false"
              error_message="請輸入搜尋關鍵字"
              @update-value="edit_key_word = $event"
            />
          </div>
          <div class="mb-5">
            <p class="mb-3 font-medium">排序方式</p>
            <div
              class="relative w-full overflow-hidden bg-transparent border rounded-md text-light-black border-zinc-300"
            >
              <i
                class="absolute z-10 text-xs transform -translate-y-1/2 pointer-events-none right-5 icon-chevron-down top-1/2 text-light-black"
              ></i>
              <select
                v-model="edit_sort_type"
                class="relative w-full px-5 py-3 bg-transparent appearance-none focus:outline-none"
              >
                <option class="bg-transparent text-light-black">
                  推薦排序
                </option>
                <option class="bg-transparent text-light-black">
                  價錢由低到高
                </option>
                <option class="bg-transparent text-light-black">
                  價錢由高到低
                </option>
                <option class="bg-transparent text-light-black">
                  時間由舊到新
                </option>
                <option class="bg-transparent text-light-black">
                  時間由新到舊
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="w-full px-3 pb-3">
          <button
            @click="SubmitFilter"
            class="w-full px-10 py-3 text-white rounded-lg bg-secondary"
          >
            套用篩選
          </button>
        </div>
      </div>

      <div
        data-dialog-background
        class="absolute top-0 left-0 z-0 w-full h-full bg-black bg-opacity-20 backdrop-blur-sm"
      ></div>
    </div>
  </Teleport>
</template>

<script>
import { Dialog } from "@/gsap/MainDialog";
import Teleport from "vue2-teleport";
import TextField from "@/components/checkout/Form/TextField.vue";
export default {
  name: "FilterDialog",
  props: {
    category_product_data: {
      require: true,
      type: Array,
    },
    filter_year: {
      require: true,
      type: Array,
    },
    sort_type: {
      require: true,
      type: String,
      default: "推薦排序",
    },
    category_data: {
      require: true,
      type: Array,
    },
    active_category_id: {
      require: true,
      type: String,
    },
    key_word: {
      require: true,
      type: String,
    },
  },
  components: {
    Teleport,
    TextField,
  },
  data() {
    return {
      dialog: false,
      edit_sort_type: "推薦排序",
      edit_key_word: "",
      dialog_gsap: null,
    };
  },
  methods: {
    Open() {
      this.edit_sort_type = this.sort_type;
      this.edit_filter_year = JSON.parse(JSON.stringify(this.filter_year));
      this.edit_key_word = this.key_word;
      this.dialog = true;
    },
    SubmitFilter() {
      this.$emit("change-sort", this.edit_sort_type);
      this.$emit("update-keyword", this.edit_key_word);
      this.dialog = false;
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        document.body.style.overflowY = "hidden";
        this.dialog_gsap.open();
      } else {
        document.body.style.overflowY = "auto";
        this.dialog_gsap.close();
      }
    },
  },
  mounted() {
    this.dialog_gsap = new Dialog(this.$refs.MainContent);
    this.dialog_gsap.reset();
    window.addEventListener("resize", () => {
      this.dialog = false;
    });
  },
};
</script>
